import React, {Component} from 'react';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import {Request} from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from "../COMPONENTS/Loader";
import {openCommentModal, openMarketingModal} from "./../../REDUX/functions";

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Marketing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
        }
    }

    componentDidMount = () => {
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.USER !== prevProps.USER) {
            this.setState({USER: this.props.USER});
        }
    }

    renderMarketingOffers = () => {
        return (
            <div className="marketing_offers_holder">
                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/instagram_logo.png"/>
                    <div className="offer_title">Наш инстаграмм</div>
                    <div className="offer_sub_title_orange">Пост</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Наша съемка – 50 000 р</div>
                        </div>
                        {/* <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Ваш контент – 30 000 р</div>
                        </div> */}
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Цена за размещение на 30 дней!</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(1)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/instagram_logo.png"/>
                    <div className="offer_title">Наш инстаграмм</div>
                    <div className="offer_sub_title_purpur">Сторис</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Наша съемка- 30 000 р</div>
                        </div>
                        {/* <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Ваш контент- 5 000 р</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Закрепление в актуальном на 30 дней 10 000 р</div>
                        </div> */}
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(2)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/green_computer.png"/>
                    <div className="offer_title">Наш сайт</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Баннер наш дизайн – 120 000р</div>
                        </div>
                        {/* <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Баннер ваш дизайн – 30 000р</div>
                        </div> */}
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Цена за размещение 7 дней</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(3)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/green_start.png"/>
                    <div className="offer_title">Размещение в категории “Популярное”</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">5-7 место – 30 000р</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">8-15 место - 25 000р</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">6-20 место - 20 000р</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">21-30+ место - 15 000р</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Цена за размещение на 7 дней</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(4)}>Подробнее</div>
                </div>

                {/* <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/green_phone.png"/>
                    <div className="offer_title">Наше приложение</div>
                    <div className="offer_sub_title_green">Сторис</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Сторис наш дизайн – 10 000 р</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Цена за размещение на 7 дней</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(5)}>Подробнее</div>
                </div> */}

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/letter.png"/>
                    <div className="offer_title">Рассылки mail</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">От 10 000р до 50 000р</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Расчет индивидуальный</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(6)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/yellow_star.png"/>
                    <div className="offer_title">Блогеры</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">от 20 000р до 500 000р</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">С нами уже больше 3000 блогеров</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">50% оплачивает Экомаркет</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">50% поставщик</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Расчет индивидуальный</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(7)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/red_terget.png"/>
                    <div className="offer_title">Контекстная \ Таргетированная реклама</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">От 20 000р до 300 000р</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">50% оплачивает Экомаркет</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">50% поставщик</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Расчет индивидуальный</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(8)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/shopping_bag.png"/>
                    <div className="offer_title">Размещение логотипа как наш партнер</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Крафт пакет: мин.тираж 20000шт - от 8р до 10р один пакет</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Термопакет: мин. тираж 5000шт - от 0р до 50р один пакет</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Цена меняется в зависимости от стороны печати и размера логотипа</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(9)}>Подробнее</div>
                </div>

                {/* <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/like_logo.png"/>
                    <div className="offer_title">Наклейки на продукции «с этим товаром покупаю» и «выбор покупателя» qr-код с переходом</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Тираж от 30 000 – 10р наклейка</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Тираж от 50 000 – 7р наклейка</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Тираж от 100 000 и больше – 5р</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(10)}>Подробнее</div>
                </div> */}

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/t-shirt.png"/>
                    <div className="offer_title">Мерч Экомаркет</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Футболки</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Фартуки</div>
                        </div>
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">Сумки шоперы</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Расчет индивидуальный</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(11)}>Подробнее</div>
                </div>

                <div className="offer_block">
                    <img className="offer_logo_img" src="/system_images/marketing_offers_navs/green_cars.png"/>
                    <div className="offer_title">Реклама на машинах</div>
                    <div className="offer_information_holder">
                        <div className="offer_information_dot_and_text">
                            <img className="dot_img" src="/system_images/blue_dot.png"/>
                            <div className="offer_information">от 10 000 р до 100 000р</div>
                        </div>
                    </div>
                    <div className="offer_flex_grown"></div>
                    <div className="offer_price">Расчет индивидуальный</div>
                    <div className="offer_details_button" onClick={() => this.props.openMarketingModal(12)}>Подробнее</div>
                </div>


            </div>
        )
    }


    render() {
        if (!this.state.USER) {
            return <Redirect to="/"/>
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Реклама</title>
                </Helmet>
                <h1>Реклама</h1>
                {this.renderMarketingOffers()}
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Marketing))
